import { render } from "./AziendeTrovateView.vue?vue&type=template&id=5e5ed31a&scoped=true"
import script from "./AziendeTrovateView.vue?vue&type=script&lang=js"
export * from "./AziendeTrovateView.vue?vue&type=script&lang=js"

import "./AziendeTrovateView.vue?vue&type=style&index=0&id=5e5ed31a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5ed31a"]])

export default __exports__